import React from 'react';

import { Box, Link as MuiLink, Stack, Typography } from '@mui/material';

interface Props {
  sections: Array<{ id: string; title: string }>;
}

export default function CompetitorOfferContents({ sections }: Props) {
  return (
    <Box
      component="nav"
      aria-label="On this page"
      sx={{
        display: { xs: 'none', lg: 'block' },
        position: 'sticky',
        top: 16,
        alignSelf: 'flex-start',
        width: 180,
        flexShrink: 0,
      }}
    >
      <Typography variant="overline" color="text.secondary">
        On this page
      </Typography>
      <Stack spacing={1} mt={0.5} pl={1.5} borderLeft={1} borderColor="divider">
        {sections.map((section) => (
          <MuiLink
            key={section.id}
            href={`#${section.id}`}
            variant="body2"
            color="text.secondary"
            underline="hover"
            onClick={(event) => {
              // Scroll without touching the URL, which the router owns.
              event.preventDefault();
              document.getElementById(section.id)?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            {section.title}
          </MuiLink>
        ))}
      </Stack>
    </Box>
  );
}
